import { Link } from "gatsby";
import { Trans, useI18next } from "gatsby-plugin-react-i18next";
import React from "react";
import "../../styles/global.css";
import { buildUrl } from "../../utils";
import LanguageSwitcher from "./LanguageSwitcher";
import LocalizationRedirect from "./LocalizationRedirect";

export default function Layout({ children }) {
  const { languages, originalPath, language: currentLanguage } = useI18next();

  return (
    <div className="min-vh-100 d-flex flex-column">
      <LocalizationRedirect />
      <header className="navbar navbar-expand-md navbar-dark d-flex">
        <nav className="container-xxl flex-wrap flex-md-nowrap" aria-label="Main navigation">
          <Link to={buildUrl(currentLanguage)} className="navbar-brand p-0 me-2">
            <img
              src="data:image/png;base64,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"
              alt="Logotipo"
            ></img>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#bdNavbar"
            aria-controls="bdNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" className="bi" fill="currentColor" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              ></path>
            </svg>
          </button>

          <div className="collapse navbar-collapse" id="bdNavbar">
            <ul className="navbar-nav flex-row flex-wrap pt-2 py-md-0">
              {/* <li className="nav-item col-6 col-md-auto">
                <Link to={buildUrl(currentLanguage)} className="nav-link">
                  Home
                </Link>
              </li> */}
              <li className="nav-item col-6 col-md-auto">
                <Link to="/#company" className="nav-link">
                  <Trans>COMPANY</Trans>
                </Link>
              </li>
              <li className="nav-item col-6 col-md-auto">
                <Link to="/#services" className="nav-link">
                  <Trans>SERVICES</Trans>
                </Link>
              </li>
              <li className="nav-item col-6 col-md-auto">
                <Link to={buildUrl(currentLanguage, "products")} className="nav-link">
                  <Trans>PRODUCTS</Trans>
                </Link>
              </li>
            </ul>

            <hr className="d-md-none text-white-50" />

            <LanguageSwitcher />

            <Link to={buildUrl(currentLanguage, "contact")} className="btn btn-outline-primary d-lg-inline-block my-2 my-md-0 ms-md-3">
              <Trans>CONTACT</Trans>
            </Link>
          </div>
        </nav>
      </header>
      {children}
      <footer className="pt-5 d-flex">
        <div className="container px-4 px-md-3">
          <div className="row">
            <div className="col-lg-3">
              <Link to={buildUrl(currentLanguage)}>
                <img
                  src="data:image/png;base64,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"
                  alt="Logotipo"
                ></img>
              </Link>

              <p className="fw-normal small mt-3">© {new Date().getFullYear()} Audácia Mobiliário Lda.</p>
              <div class="mt-4">
                <ul className="m-0 list-group list-group-horizontal">
                  <li className="me-3">
                    <a className="icon" href="https://www.facebook.com/audaciamobiliario" target="_blank" rel="noreferrer">
                      <img src="/facebook.svg" alt="facebook link-footer" width="24px" />
                    </a>
                  </li>
                  <li>
                    <a className="icon" href="https://www.instagram.com/audaciahomelovers" target="_blank" rel="noreferrer">
                      <img src="/instagram.svg" alt="instagram link-footer" width="24px" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <dl className="row mt-2">
                <dt className="col-12">
                  <Trans>PHONE</Trans>
                </dt>
                <dd className="col-12">
                  +351 919 374 005
                  <br />
                  +351 917 615 483
                </dd>

                <dt className="col-12">Email</dt>
                <dd className="col-12">
                  <a href="mailto:geral@audacia.pt" className="link-footer" alt="email">
                    geral@audacia.pt
                  </a>
                  &nbsp;
                </dd>
              </dl>
            </div>
            <div className="col-lg-3">
              {/* <Trans>Links uteis</Trans> */}
              <div className="mt-2">
                <Link to="/#company" className="link-footer">
                  <Trans>COMPANY</Trans>
                </Link>
              </div>
              <div className="mt-2">
                <Link to="/#services" className="link-footer">
                  <Trans>SERVICES</Trans>
                </Link>
              </div>
              <div className="mt-2">
                <Link to={buildUrl(currentLanguage, "products")} className="link-footer">
                  <Trans>PRODUCTS</Trans>
                </Link>
              </div>
              <div className="mt-2">
                <Link to={buildUrl(currentLanguage, "contact")} className="link-footer">
                  <Trans>CONTACT</Trans>
                </Link>
              </div>
              <div className="mt-2">
                <a href="https://www.livroreclamacoes.pt/inicio" target={"_blank"} rel="noreferrer" className="link-footer">
                  <Trans>COMPLAINTS_BOOK</Trans>
                </a>
              </div>
              <div className="mt-2">
                <Link to={buildUrl(currentLanguage, "cookies")} className="link-footer">
                  <Trans>COOKIE_POLICY</Trans>
                </Link>
              </div>
            </div>
            <div className="col-lg">
              {/* <div className="row">
                <div className="col-lg text-end mb-3 mb-lg-0">
                  <Link to={buildUrl(currentLanguage, "history")} className="link-footer">
                    <Trans>COMPANY</Trans>
                  </Link>
                </div>
                <div className="col-lg-2 text-end mb-3 mb-lg-0">
                  <Link to={buildUrl(currentLanguage, "services")} className="link-footer">
                    <Trans>SERVICES</Trans>
                  </Link>
                </div>
                <div className="col-lg-2 text-end mb-3 mb-lg-0">
                  <Link to={buildUrl(currentLanguage, "products")} className="link-footer">
                    <Trans>PRODUCTS</Trans>
                  </Link>
                </div>
                <div className="col-lg-3 text-end mb-3 mb-lg-0">
                  <Link to={buildUrl(currentLanguage, "contact")} className="btn btn-outline-primary">
                    <Trans>CONTACT</Trans>
                  </Link>
                </div>
              </div> */}

              <div className="text-end">
                <Link to={buildUrl(currentLanguage, "contact")} className="btn btn-outline-primary">
                  <Trans>CONTACT</Trans>
                </Link>
              </div>

              <div className="dropdown d-flex justify-content-end mt-5">
                <button
                  className="btn btn-outline-primary dropdown-toggle d-flex align-items-center bg-transparent btn-footer-culture"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img height="15" className="globe-localization-color me-2" src="/globe.svg" alt="" />
                  <Trans>{currentLanguage}</Trans>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  {languages
                    .filter(x => x !== currentLanguage)
                    .sort()
                    .map(lng => (
                      <li key={lng}>
                        <Link className="dropdown-item" to={buildUrl(lng, originalPath)} language={lng}>
                          <Trans>{lng}</Trans>
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
